<template>
  <!-- <div class="custom-click-view" @click="handClick">{{text | defaultShow}}</div> -->
  <!-- <gj-button :class="clickAble ? 'custom-click-view' : ''" @click="handClick" type="text" >{{showText}}</gj-button> -->
    <div class="custom-click-default" :class="clickAble ? 'custom-click-view2' : ''" @click="handClick"  >{{text}}</div>
</template>
 

<script>
import {isMeaningful} from "@/utils/common";


export default {
  name: "data-click-view",
  props: {
    text: null,
    overflowLine: 2
  },
 
  data() {
    return {
      // showText: '-'
    }
  },
  // watch:{
  //   text(val){
  //     this.showText = val;
  //   }
  // },
  created() {
    
  },
  computed: {
    clickAble(){
      return isMeaningful(this.text) && this.text!= '-';
    }
  },
  methods: {
    handClick(){
      if(this.clickAble){
        this.$emit('dataClick');
      }
    },
  }
}
</script>

<style scoped lang="scss">

.row--hover {
  .custom-click-view2{
    color:#1F6EEF;
    // text-decoration:underline;//下划线
    cursor:pointer;
  }
}

.custom-click-default{
  overflow: hidden;
  text-overflow: ellipsis;  /* 超出部分省略号 */
  word-break: break-all;  /* break-all(允许在单词内换行。) */  
  display: -webkit-box; /* 对象作为伸缩盒子模型显示 */
  -webkit-box-orient: vertical; /* 设置或检索伸缩盒对象的子元素的排列方式 */
  -webkit-line-clamp: 2; /* 显示的行数 */
}


</style>
